// extracted by mini-css-extract-plugin
module.exports =  {"form":"Form-module__form___Nl9sb"};